import SignaturePad, { PointGroup } from 'signature_pad';
import { BasicPoint } from 'signature_pad';

export class SignaturePoint {
	constructor(initial: Partial<SignaturePoint> | BasicPoint) {
		if (initial) {
			this.x = initial.x;
			this.y = initial.y;
			this.pressure = initial.pressure;
			// BasicPoint has 'time' property, while SignaturePoint has 'timestamp'
			if ('time' in initial) {
				this.timestamp = initial.time;
			} else if ('timestamp' in initial) {
				this.timestamp = initial.timestamp;
			}
		}
	}

	x: number;
	y: number;
	pressure: number;
	timestamp: number;
}

export class SignatureStroke {
	constructor(initial: Partial<SignatureStroke> | PointGroup) {
		if (initial) {
			if ('penColor' in initial) {
				this.color = initial.penColor;
			} else if ('color' in initial) {
				this.color = initial.color;
			}
			this.dotSize = initial.dotSize;
			this.maxWidth = initial.maxWidth;
			this.minWidth = initial.minWidth;
			this.velocityFilterWeight = initial.velocityFilterWeight;

			if (initial.points != null) {
				this.points = initial.points.map((p: any) => new SignaturePoint(p));
			}
		}
	}
	points: SignaturePoint[];
	color: string;
	dotSize: number;
	maxWidth: number;
	minWidth: number;
	velocityFilterWeight: number;
}

export class DigitalSignatureData {
	constructor(initial: Partial<DigitalSignatureData> | SignaturePad) {
		if (initial) {
			this.velocityFilterWeight = initial.velocityFilterWeight;
			this.dotSize = initial.dotSize;
			this.maxWidth = initial.maxWidth;
			this.minWidth = initial.minWidth;
			this.throttle = initial.throttle;
			this.compositeOperation = initial.compositeOperation;
			this.backgroundColor = initial.backgroundColor;
			this.color = 'penColor' in initial ? initial.penColor : initial.color;
			if ('strokes' in initial && initial.strokes != null) {
				this.strokes = initial.strokes.map((s: any) => new SignatureStroke(s));
			} else if ('toData' in initial && initial.toData != null) {
				this.strokes = initial.toData().map((s: any) => new SignatureStroke(s));
			}
		}
	}
	strokes: SignatureStroke[];
	velocityFilterWeight: number;
	dotSize: number;
	maxWidth: number;
	minWidth: number;
	throttle: number;
	compositeOperation: string;
	backgroundColor: string;
	color: string;
}
